module.exports = __webpack_public_path__ + "mainassets/img/navbar-vector.609b8010.svg";